
import { Options, Vue, prop } from "vue-class-component";

interface ImagePreviewProps {
  title: string;
  images: string[];
  titleImages: string[];
  initialIndex: number;
}

@Options({
  props: {
    title: {
      type: String,
      required: true
    },
    images: {
      type: Array as () => string[],
      required: true
    },
    titleImages: {
      type: Array as () => string[],
      required: true
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  emits: ["close"]
})
export default class ImagePreview extends Vue {
  declare $props: ImagePreviewProps;

  private currentIndex = 0;
  private isDownloading = false;

  created() {
    this.currentIndex = this.$props.initialIndex;
  }

  previousImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  nextImage() {
    if (this.currentIndex < this.$props.images.length - 1) {
      this.currentIndex++;
    }
  }

  async handleDownload() {
    try {
      this.isDownloading = true;

      const response = await fetch(this.$props.images[this.currentIndex]);
      if (!response.ok) throw new Error("Gagal mengunduh gambar");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      
      const fileName =
        this.$props.titleImages[this.currentIndex] ||
        `image-${this.currentIndex + 1}`;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading image:", error);
    } finally {
      this.isDownloading = false;
    }
  }
}
